import React from "react";
import ScreenCard from "./Card";
import {Container, Row, Col} from "react-bootstrap";
// import {Grid} from "@mui/material"; // Removing MUI Grid

export default function CardLayout({data}) {

    if (data[0] == null) return null;
    
    return (
        <Container fluid className="px-0">
             <Row className="gy-4"> 
            {data.map((screening,idx) =>{
             return(
                <Col xs={12} sm={6} md={4} key={"grid"+idx} className="d-flex">
                    <ScreenCard data={screening} key={idx}/>
                </Col>
            )
            })}

        </Row>
        </Container>
    );
}